import React, { Component } from 'react';
import { Row, Col, H1, Form, FormField, Button, Card, CardContent, CheckBox, Translate } from '$common';

export default class Notifications extends Component {
  render() {
    const {
      account,
      onSubmit,
      errors
    } = this.props;

    return (
      <div>
        <H1>{Translate.get('notifications')}</H1>
        <Card>
          <CardContent>
            <Form defaults={account} onSubmit={onSubmit} errors={errors}>
              <Row>
                <Col>
                  <FormField
                    name="notificationSettings[every_day_summary_email]"
                    label={Translate.get('notification_setting_1')}>

                    <CheckBox />
                  </FormField>

                  <FormField
                    name="notificationSettings[weekly_summary_email]"
                    label={Translate.get('notification_setting_2')}>

                    <CheckBox />
                  </FormField>

                  <FormField
                    name="notificationSettings[over_50_percent_email]"
                    label={Translate.get('notification_setting_3')}>

                    <CheckBox />
                  </FormField>

                  <FormField
                    name="notificationSettings[over_75_percent_email]"
                    label={Translate.get('notification_setting_4')}>

                    <CheckBox />
                  </FormField>

                  <FormField
                    name="notificationSettings[over_90_percent_email]"
                    label={Translate.get('notification_setting_5')}>

                    <CheckBox />
                  </FormField>

                  <FormField
                    name="notificationSettings[project_finished_email]"
                    label={Translate.get('notification_setting_6')}>

                    <CheckBox />
                  </FormField>
                </Col>

                <Col md="1/2">
                  <Button type="success" block>{Translate.get('save_changes')}</Button>
                </Col>
              </Row>
            </Form>
          </CardContent>
        </Card>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/account/notifications.js